import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { Form } from "react-bootstrap";

export default function InputLeftIcon({
  icon,
  isInvalid,
  isInvalidMessage,
  type,
  style,
  ...other
}) {
  // state
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <div style={{ position: "relative" }}>
        <div
          style={{
            top: 0,
            left: 10,
            position: "absolute",
            height: "100%",
            display: "flex",
            alignItems: "center",
            color: "#6C757D",
          }}
        >
          {icon}
        </div>
        <div
          style={{
            top: 0,
            right: 10,
            position: "absolute",
            height: "100%",
            display: type === "password" ? "flex" : "none",
            alignItems: "center",
            color: "#6C757D",
            cursor: "pointer",
          }}
          onClick={() => setShowPassword((prev) => !prev)}
        >
          <Icon
            icon={!showPassword ? "uil:eye-slash" : "uil:eye"}
            style={{ width: 24, height: 24 }}
          />
        </div>
        <Form.Control
          style={{ paddingLeft: 40, ...style }}
          isInvalid={isInvalid}
          {...other}
          type={(type === "password") & showPassword ? "text" : type}
        />
      </div>
      {/*  */}
      <div
        style={{
          display: isInvalid ? "flex" : "none",
          color: "#FF0000",
          gap: 5,
          alignItems: "center",
        }}
      >
        <Icon
          icon="material-symbols:info-outline"
          style={{ width: 18, height: 18 }}
        />
        <span>
          {isInvalidMessage ? isInvalidMessage : "ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ"}
        </span>
      </div>
    </div>
  );
}
